module.exports = __webpack_public_path__ + "img/Marquee-03.3c90fc6e.jpg";